/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FailedRansomwareRecoveryDeploymentSpec { 
    /**
     * Group Id generated for org and CBC Geo POP region pair
     */
    activation_group_id?: string;
    /**
     * AWS region
     */
    aws_region?: string;
    /**
     * Activated CBC Geo POP region
     */
    cb_pop_id?: string;
    /**
     * Ransomware Recovery Deployment ID
     */
    id?: string;
    /**
     * Reason to fail operation.
     */
    reason?: string;
}

